import React from 'react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
    flex-direction: row;
  }
`;
export const MetaInfo = styled.div`
  flex-grow: 1;

  @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
    padding-left: ${({ theme }) => theme.spacing.md};
  }
`;
export const ImageContainer = styled.div`
  flex-basis: 60%;

  img {
    max-width: 100%;
    max-height: 600px;
  }
`;

function AnythingDetailsImageS3({ anything, ...rest }) {
  const { value1: fileKey, value2: originalName, signedUrl } = anything;

  return (
    <div {...rest}>
      <Container>
        <ImageContainer>
          <img src={signedUrl} alt={originalName} />
        </ImageContainer>
        <MetaInfo>
          <p>{originalName}</p>
          <p>{fileKey}</p>
        </MetaInfo>
      </Container>
    </div>
  );
}

export default AnythingDetailsImageS3;
